import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';
import DeliveryEstimate from '../DeliveryEstimate';
import DeliveryContainer from '../../containers/logistics/StationDelivery';
import Transition from './Transition';

const styles = (theme) => ({
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	dialogPaper : {
		overflow: 'scroll',
		width: '90%',
		maxWidth: '90%',
	},
});

class DeliveryEstimateDialog extends Component {
	constructor (props) {
		super(props);
		this.state = {
			isFetchingEstimate: false,
			estimate: undefined,
		};
		this.handleClose = this.handleClose.bind(this);
	}

	componentDidUpdate(prevProps) {
		const {
			stationId,
			tankNumber,
			estimateDelivery,
			showErrors,
		} = this.props;

		if (
			prevProps.stationId !== stationId ||
			prevProps.tankNumber !== tankNumber
		) {
			this.setState({ isFetchingEstimate : true });
			setTimeout(() => {
				estimateDelivery({
					params: {
						stationIds: [stationId],
					},
					callback: (err, r) => {
						if (err) { return showErrors([err]); }
						const estimate = _.find(r, {stationId, tankNumber});
						let newState = {};

						if (!estimate) {
							newState.estimate = {isMissing: true};
							newState.isFetchingEstimate = false;
						} else {
							newState.estimate = estimate;
							newState.isFetchingEstimate = false;
						}
						this.setState(newState);
					}
				});
			}, 500);
		}
	}

	handleClose () {
		this.props.onClose();
	}

	render () {
		const {classes, fullScreen } = this.props;
		const {isFetchingEstimate, estimate } = this.state;

		/** @namespace jobResult.htmlBody **/
		/** @namespace jobResult.textBody **/
		/** @namespace jobResult.carrierEmailRecipients **/
		/** @namespace jobResult.supplierEmailRecipients **/
		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth='md'
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper
				}}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>
						Delivery Estimate
					</DialogTitle>
					<DialogContent>
						<DeliveryEstimate
							isFetching={isFetchingEstimate}
							deliveryEstimate={estimate}
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>
							Close
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

DeliveryEstimateDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	stationId : PropTypes.number,
	tankNumber : PropTypes.number,

	estimateDelivery : PropTypes.func,
	showErrors : PropTypes.func,
	classes: PropTypes.object.isRequired,
	fullScreen: PropTypes.bool.isRequired,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
	DeliveryContainer,
])(DeliveryEstimateDialog);